import { SET_KIOSK_SETTINGS } from '../types/kioskSettings'
import { getKioskSettingsAPI, saveKioskSettingsAPI } from '../api/kioskSettings'
import { addMessageCurry } from '../utils/api'

export const setKioskSettings = (payload) => ({
  type: SET_KIOSK_SETTINGS,
  payload: payload,
})

export const getKioskSettings = () => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      addMessageCurry(getKioskSettingsAPI(), dispatch)
        .then((kioskSettings) => {
          resolve(kioskSettings)
          dispatch(setKioskSettings({ kioskSettings }))
        })
        .catch((err) => console.log(err))
    })
  }
}

export const saveKioskSettings = (data) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      addMessageCurry(saveKioskSettingsAPI(data), dispatch)
        .then((kioskSettings) => {
          resolve(kioskSettings)
          dispatch(setKioskSettings({ kioskSettings }))
        })
        .catch((err) => console.log(err))
    })
  }
}



// WEBPACK FOOTER //
// ./src/actions/kioskSettings.js